import React from "react";
import { State } from "./types";

interface StatusControllerProps {
  state: State;
}

const StatusController: React.FC<StatusControllerProps> = ({ state }) => {
  const getStatusSection = (
    status: string,
    btnClass: string,
    typeClass: string
  ) => (
    <div className="status-section-active">
      <div className={btnClass}></div>
      <div className={typeClass}>{status}</div>
    </div>
  );

  return (
    <div className="status-section">
      {state === "Active" &&
        getStatusSection("Active", "status-btn-active", "status-type-active")}
      {state === "Pending" &&
        getStatusSection(
          "Requested",
          "status-btn-disable",
          "status-type-disable"
        )}
      {state === "Inactive" &&
        getStatusSection(
          "Inactive",
          "status-btn-inactive",
          "status-type-inactive"
        )}
    </div>
  );
};

export default StatusController;
